'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var PropTypes = require('prop-types');
var index = require('../core/index.js');
var icon = require('./icon.js');
var space = require('./space.js');
var useDidUpdate = require('../hooks/useDidUpdate.js');
var Vimeo = require('@u-wave/react-vimeo');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var Vimeo__default = /*#__PURE__*/_interopDefaultLegacy(Vimeo);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: 320px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  bottom: 40px;\n  left: 26px;\n  right: 26px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  height: 7px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  transition: 1s all cubic-bezier(0.33, 0.26, 0.91, 0.93);\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 300px;\n  height: 7px;\n  z-index: 2;\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  left: 8px;\n  background: rgba(255, 255, 255, 0.4);\n  border-radius: 25px;\n  box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.3);\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 320px;\n  position: relative;\n  overflow: hidden;\n  background-color: green;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var VideoWrapper = styled__default['default'].div(_templateObject());
var ProgessBar = styled__default['default'].div(_templateObject2());
var Progress = styled__default['default'].span(_templateObject3(), index.styleEngine);
var Navigation = styled__default['default'].div(_templateObject4());
var Story = styled__default['default'].div(_templateObject5());

var VideoPlayer = function VideoPlayer(_ref) {
  var hasProgressBar = _ref.hasProgressBar,
      _ref$video = _ref.video,
      video = _ref$video === void 0 ? [] : _ref$video,
      navigateIconProps = _ref.navigateIconProps,
      onClose = _ref.onClose,
      restProps = _objectWithoutProperties(_ref, ["hasProgressBar", "video", "navigateIconProps", "onClose"]);

  var _useState = React.useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      videoElpassed = _useState2[0],
      setVideoElpassed = _useState2[1];

  var _useState3 = React.useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      totalDuration = _useState4[0],
      setTotalDuration = _useState4[1];

  var _useState5 = React.useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      storyInDirection = _useState6[0],
      setStoryInDirection = _useState6[1];

  var _useState7 = React.useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      swipeCount = _useState8[0],
      setSwipeCount = _useState8[1];

  console.log(_objectSpread({}, restProps));
  useDidUpdate['default'](function () {
    var progressBarFunc = setInterval(function () {
      setVideoElpassed(function (videoElpassed) {
        return videoElpassed + 1;
      });
    }, totalDuration / 100);
    var progrssTimeOut = setTimeout(function () {
      clearInterval(progressBarFunc);
    }, totalDuration);
    return function () {
      clearTimeout(progrssTimeOut);
    };
  }, [totalDuration]);
  React.useEffect(function () {
    if (videoElpassed === 100) {}
  }, [videoElpassed]);

  var iconProps = _objectSpread({
    color: '#FFFFFF',
    position: 'absolute',
    fontSize: '24px',
    fontWeight: 'bold',
    cursor: 'pointer'
  }, navigateIconProps);

  var spaceProps = {
    position: 'relative',
    transition: 'all .4s ease-in-out',
    left: storyInDirection === 'left' ? "".concat(swipeCount * 320, "px") : null,
    right: storyInDirection === 'right' ? "".concat(swipeCount * 320, "px") : null
  };

  var onPlay = function onPlay(metadata) {
    setTotalDuration(metadata.duration * 1000);
  };

  var onSwipeRight = function onSwipeRight() {
    setStoryInDirection('right');
    swipeCount !== video.length - 1 && setSwipeCount(function (swipeCount) {
      return swipeCount + 1;
    });
  };

  var onSwipeLeft = function onSwipeLeft() {
    setStoryInDirection('left');
    swipeCount !== 0 && setSwipeCount(function (swipeCount) {
      return swipeCount - 1;
    });
  };

  return /*#__PURE__*/React__default['default'].createElement(VideoWrapper, null, hasProgressBar && totalDuration && /*#__PURE__*/React__default['default'].createElement(ProgessBar, null, /*#__PURE__*/React__default['default'].createElement(Progress, {
    width: "".concat(videoElpassed, "%")
  })), Array.isArray(video) ? /*#__PURE__*/React__default['default'].createElement(space['default'], _extends({}, spaceProps, {
    gutter: 0,
    direction: "horizontal"
  }), video.map(function (_ref2, index) {
    var videoLink = _ref2.videoLink,
        otherProps = _objectWithoutProperties(_ref2, ["videoLink"]);

    return /*#__PURE__*/React__default['default'].createElement(Story, {
      key: index // onTouchMove={(e) =>
      //   handleTouchMove(e, { onSwipeRight, onSwipeLeft })
      // }

    }, /*#__PURE__*/React__default['default'].createElement(Vimeo__default['default'], _extends({}, otherProps, {
      video: videoLink,
      onPlay: onPlay,
      controls: false
    })));
  })) : /*#__PURE__*/React__default['default'].createElement(Vimeo__default['default'], _extends({}, restProps, {
    video: video,
    onPlay: onPlay,
    controls: false
  })), hasProgressBar && totalDuration && /*#__PURE__*/React__default['default'].createElement(Navigation, null, swipeCount !== 0 && /*#__PURE__*/React__default['default'].createElement(icon['default'], _extends({}, iconProps, {
    left: 0,
    onClick: function onClick() {
      var _iconProps$rightArrow = iconProps.rightArrowProps,
          rightArrowProps = _iconProps$rightArrow === void 0 ? {} : _iconProps$rightArrow;
      var onCLick = rightArrowProps.onCLick;
      onCLick && onCLick();
      onSwipeLeft();
    },
    icon: "pyt-arrow-left-circle-16"
  })), /*#__PURE__*/React__default['default'].createElement(icon['default'], _extends({}, iconProps, {
    onClick: onClose,
    icon: "pyt-close-circle-16"
  })), swipeCount !== video.length - 1 && /*#__PURE__*/React__default['default'].createElement(icon['default'], _extends({}, iconProps, {
    right: 0,
    onClick: function onClick() {
      var _iconProps$leftArrowP = iconProps.leftArrowProps,
          leftArrowProps = _iconProps$leftArrowP === void 0 ? {} : _iconProps$leftArrowP;
      var onCLick = leftArrowProps.onCLick;
      onCLick && onCLick();
      onSwipeRight();
    },
    icon: "pyt-arrow-right-circle-16"
  }))));
};

VideoPlayer.propTypes = {
  onProgress: PropTypes__default['default'].func,
  hasProgressBar: PropTypes__default['default'].bool,
  video: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].array]),
  navigateIconProps: PropTypes__default['default'].object
};

exports.default = VideoPlayer;
